import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import axiosApiInstance from "app/services/axios";
import { getDataEndPoint, updateDataEndPoint } from "app/utils/constants/paths";
import { DATASOURCE_CONFIG } from "app/config";

//import axiosApiInstance from "../../axios";
import { toast } from "react-toastify";
import { getTimeDifference } from "app/utils/utils";
const tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  openRequestsList: [],
  requestHistoryList: [],
};

export const GetAllOpenRequestsListThunk = createAsyncThunk(
  "ConsentManagement/GetAllOpenRequestsListThunk",
  async (payload) => {
    try {
      const queryBody = {
        queries: [
          {
            query:
              payload.status == "3"
                ? "select r.id,r.email,r.full_name,r.status,r.type,r.updated_date,cs.name as source," + DATASOURCE_CONFIG.REQUEST_DATE_DIFF + " from " +
                tablePrefix +
                "requests_1  as r," +
                tablePrefix +
                "crm_sources as cs where cs.id=r.crm_source_id and r.account_id='1' and  (status in ('1','-1') or (status='0' and  " + DATASOURCE_CONFIG.REQUEST_DATE_DIFF + "<=3)) order by r.id"
                : "select r.id, r.email, r.full_name, r.status, r.type, r.updated_date, cs.name as source from " +
                tablePrefix +
                "requests_1  as r, " +
                tablePrefix +
                "crm_sources as cs where cs.id = r.crm_source_id and r.account_id = '1'  order by r.id",
            datasource: DATASOURCE_CONFIG.DATASOURCE,
          },
        ],
      };
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetAllRequestHistoryListThunk = createAsyncThunk(
  "ConsentManagement/GetAllRequestHistoryListThunk",
  async (payload) => {
    try {
      const queryBody = {
        queries: [
          {
            query:
              "select r.id,r.email,r.full_name,r.status,r.type,r.updated_date,cs.name as source," + DATASOURCE_CONFIG.REQUEST_DATE_DIFF + " from " +
              tablePrefix +
              "requests_1 as r," +
              tablePrefix +
              "crm_sources as cs where cs.id=r.crm_source_id and r.account_id='1' and r.status='1' order by r.id",
            datasource: DATASOURCE_CONFIG.DATASOURCE,
          },
        ],
      };
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const updateRequestStatusThunk = createAsyncThunk(
  "ConsentManagement/updateRequestStatusThunk",
  async (payload) => {
    try {
      const queryBody = {
        queries: [
          {
            query:
              "update " +
              tablePrefix +
              "requests_" +
              payload.selGlobalAccount +
              "  set status='" +
              payload.status +
              "' where id='" +
              payload.id +
              "' ",
            datasource: DATASOURCE_CONFIG.DATASOURCE,
          },
        ],
      };
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const ConsentManagement = createSlice({
  name: "ConsentManagement",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(GetAllOpenRequestsListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllOpenRequestsListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results.length > 0) {
          let listData = action.payload.data.results[0];

          listData.map((item) => {
            item["updated_date"] = getTimeDifference(item["updated_date"]);
            if (item["status"] == "-1") {
              item["status"] = "Pending";
            } else if (item["status"] == "1") {
              item["status"] = "Processing";
            } else {
              item["status"] = "Completed";
            }
          });
          //console.log('listData', listData);
          state.openRequestsList = listData;
        } else {
          // toast.error(action.payload.data.message);
        }
        console.log("error");
        state.loading = false;
      })
      .addCase(GetAllOpenRequestsListThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
      })
      .addCase(GetAllRequestHistoryListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllRequestHistoryListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results.length > 0) {
          let listData = action.payload.data.results[0];

          listData.map((item) => {
            item["updated_date"] = getTimeDifference(item["updated_date"]);
            if (item["status"] == "-1") {
              item["status"] = "Pending";
            } else if (item["status"] == "0") {
              item["status"] = "InProgress";
            } else {
              item["status"] = "Completed";
            }
          });
          console.log("listData", listData);
          state.requestHistoryList = listData;
        } else {
          // toast.error(action.payload.data.message);
        }

        state.loading = false;
      })
      .addCase(GetAllRequestHistoryListThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
      })

      .addCase(updateRequestStatusThunk.pending, (state) => {
        //state.loading = true;
      })
      .addCase(updateRequestStatusThunk.fulfilled, (state, action) => {
        if (
          action.payload.data?.results.length > 0 &&
          action.payload.data.results.includes("Updated")
        ) {
          let listData = state.openRequestsList;
          let requestId = action.meta.arg.id;
          listData.map((item) => {
            if (item["id"] == requestId) {
              item["status"] = "Processing";
            }
          });
          console.log("listData", listData);
          state.openRequestsList = listData;
        } else {
          // toast.error(action.payload.data.message);
        }

        //state.loading = false;
      })
      .addCase(updateRequestStatusThunk.rejected, (state, action) => {
        toast.error("Something went Wrong!");
      });
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = ConsentManagement;
// Extract and export each action creator by name
//export const { logOut } = actions;
// Export the reducer, either as a default or named export
export default reducer;
